module.exports = "<div class=\"ui-card\">\r\n  <div ng-repeat=\"item in $ctrl.data track by $index\">\r\n    <viaticos-shared-comprobantes-agregar-errores-item\r\n        data=\"item\"\r\n        on-delete=\"$ctrl.eliminar(item)\"></viaticos-shared-comprobantes-agregar-errores-item>\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/viaticos/components/shared/comprobantes/agregar/errores/template.html
// module id = 3304
// module chunks = 0